import _ from 'lodash';

import { LogEntry, LogEntryExtra, LogEntryType } from '@/parsing/LogEntry';
import { LogLine } from '@/parsing/LogLine';

export interface SerializedLogEntry {
  index: number;
  entryType: LogEntryType;
  originalLines: LogLine[];
  date: Date;
  secondsSinceFirstLogEntry: number;
  content: string;
  extra: any;
}

export function serializeLogEntry(e: LogEntry): SerializedLogEntry {
  const serializedExtra: any = _.clone(e.extra);
  if (e.extra.networkRequest && e.extra.networkRequest.url) {
    serializedExtra.networkRequest.url = e.extra.networkRequest.url.toString();
  }

  return {
    index: e.index,
    entryType: e.entryType,
    originalLines: e.originalLines,
    date: e.date,
    secondsSinceFirstLogEntry: e.secondsSinceFirstLogEntry,
    content: e.content,
    extra: serializedExtra,
  };
}

export function deserializeLogEntry(e: SerializedLogEntry): LogEntry {
  const deserializedExtra: LogEntryExtra = _.clone(e.extra);
  if (deserializedExtra.networkRequest && e.extra.networkRequest.url) {
    deserializedExtra.networkRequest.url = new URL(e.extra.networkRequest.url);
  }

  return {
    index: e.index,
    entryType: e.entryType,
    originalLines: e.originalLines,
    date: e.date,
    secondsSinceFirstLogEntry: e.secondsSinceFirstLogEntry,
    content: e.content,
    extra: e.extra,
  };
}
